export default __webpack_public_path__ + "static/Supreme-Italic-a316bbc243042c99611952d690025ce2.woff";